import { type ReactNode, createContext, useMemo } from 'react'

import { type SanityFrameBuilderStrings } from '@frame-builder/data/sanity/queries/types/strings'
import { emptyFrameBuilderStrings } from '@frame-builder/lib/strings'

type FrameBuilderStringsProps = SanityFrameBuilderStrings

interface FrameBuilderStringsProviderProps {
  strings: SanityFrameBuilderStrings | null
  children: ReactNode
}

export const FrameBuilderStringsContext =
  createContext<FrameBuilderStringsProps>(emptyFrameBuilderStrings)

export const FrameBuilderStringsProvider = ({
  strings,
  children,
}: FrameBuilderStringsProviderProps) => {
  const frameBuilderStrings = useMemo(() => {
    const frameBuilderStrings: SanityFrameBuilderStrings = {
      ...emptyFrameBuilderStrings,
      ...(strings ?? {}),
    }

    return frameBuilderStrings
  }, [strings])

  return (
    <FrameBuilderStringsContext.Provider value={frameBuilderStrings}>
      {children}
    </FrameBuilderStringsContext.Provider>
  )
}
